<h2 matDialogTitle>{{data.message}}</h2>
<mat-dialog-content>
  <p style="color:red">{{data.error}}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button matDialogClose="cancel" color="primary">Cancel</button>
  <button mat-button matDialogClose="confirm" color="primary" (click)="ok()">OK</button>
</mat-dialog-actions>